module.exports = __webpack_public_path__ + "static/img/tishi@2x.c6cda1cf.png";